








import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class SectionTitle extends Vue {
    @Prop({ default: '' }) title: string;
    @Prop({ default: '' }) customClass: string;
    @Prop({ default: false }) headline: boolean;
}
